export var ToastType;

(function (ToastType) {
  ToastType["CAUTION"] = "caution";
  ToastType["INFO"] = "info";
  ToastType["SUCCESS"] = "success";
  ToastType["WARNING"] = "warning";
})(ToastType || (ToastType = {}));

export var ToastWrapperPosition;

(function (ToastWrapperPosition) {
  ToastWrapperPosition["TOP"] = "top";
  ToastWrapperPosition["TOP_LEFT"] = "top-left";
  ToastWrapperPosition["TOP_RIGHT"] = "top-right";
  ToastWrapperPosition["BOTTOM"] = "bottom";
  ToastWrapperPosition["BOTTOM_LEFT"] = "bottom-left";
  ToastWrapperPosition["BOTTOM_RIGHT"] = "bottom-right";
})(ToastWrapperPosition || (ToastWrapperPosition = {}));